<div class="amadeus-direct-style">
  <div class="error-page-wrap">
    <div class="error-page-top">
      <div class="wrap">
        <div class="error-type">{{ errorPageType }}</div>
        <div class="error-number-holder">
          <svg>
            <use [attr.xlink:href]="errorhref"></use>
          </svg>
        </div>
        <div class="error-page-title" [innerHTML]="errorPageTitle"></div>
        <div class="error-page-subtitle" [innerHTML]="errorPageSubtitle"></div>
      </div>
    </div>

    <ng-container *ngIf="showSocial">
      <div class="error-page-bottom">
        <div class="wrap">
          <div class="socials-title my-6">
            {{ errorPageSocialLinksTitle }}
          </div>
          <ul class="error-page-socials clearfix">
            <li *ngIf="facebook">
              <a href="{{ facebook }}" target="_blank" rel="noopener noreferrer" class="fb">
                <img src="/assets/images/svg_ico/icons.svg#ic_facebook_outline"
                  alt="facebook ico" style="width: 90px; height: 90px;" />
              </a>
            </li>
            <li *ngIf="twitter">
              <a href="{{ twitter }}" target="_blank" rel="noopener noreferrer" class="twitter">
                <img src="/assets/images/svg_ico/icons.svg#ic_twitter_outline"
                  alt="twitter ico" style="width: 90px; height: 90px;" />
              </a>
            </li>
            <li *ngIf="linkedin">
              <a href="{{ linkedin }}" target="_blank" rel="noopener noreferrer" class="linkedin">
                <img src="/assets/images/svg_ico/icons.svg#ic_linkedin_outline"
                  alt="linkedin ico" style="width: 90px; height: 90px;" />
              </a>
            </li>
            <li *ngIf="youtube">
              <a href="{{ youtube }}" target="_blank" rel="noopener noreferrer" class="youtube">
                <img src="/assets/images/svg_ico/icons.svg#ic_youtube_outline"
                  alt="youtube ico" style="width: 90px; height: 90px;" />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </ng-container>
  </div>
</div>
